const RANKING = [
  {
    rank: 1,
    title: '《重生之都市修仙》',
    type: '国漫·热血',
    hot: '本周 128.6w 阅读',
    trend: 'up',
    medal: 'ri-medal-line',
    medalColor: 'text-amber-500',
  },
  {
    rank: 2,
    title: '《霸道总裁的契约新娘》',
    type: '韩漫·恋爱',
    hot: '本周 112.3w 阅读',
    trend: 'up',
    medal: 'ri-medal-line',
    medalColor: 'text-foreground-300',
  },
  {
    rank: 3,
    title: '《咒术回战·外传》',
    type: '日漫·战斗',
    hot: '本周 98.7w 阅读',
    trend: 'up',
    medal: 'ri-medal-line',
    medalColor: 'text-amber-600',
  },
  {
    rank: 4,
    title: '《财阀家的小儿子》',
    type: '韩漫·重生',
    hot: '本周 87.2w 阅读',
    trend: 'down',
    medal: '',
    medalColor: '',
  },
  {
    rank: 5,
    title: '《我在诡异世界当NPC》',
    type: '国漫·悬疑',
    hot: '本周 76.5w 阅读',
    trend: 'up',
    medal: '',
    medalColor: '',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">人气榜单</h2>
          <p className="text-sm text-foreground-600">
            本周最受漫迷欢迎的漫画作品排行榜，韩漫日漫国漫全面覆盖
          </p>
        </div>

        <div className="space-y-2">
          {RANKING.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-xl px-4 py-3.5 md:px-5 md:py-4 hover:border-primary-200 hover:bg-primary-50/10 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-background-100 flex-shrink-0">
                <span className={`text-sm font-heading ${item.rank <= 3 ? 'text-primary-500' : 'text-foreground-500'}`}>
                  {item.rank}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.medal && (
                    <i className={`${item.medal} text-sm ${item.medalColor} flex-shrink-0`}></i>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{item.type}</span>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-xs text-green-500"></i>
                ) : (
                  <i className="ri-arrow-down-line text-xs text-red-500"></i>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>

        <p className="text-center mt-6 text-xs text-foreground-400">
          榜单每周一更新 · 数据统计截止至昨日 23:59
        </p>
      </div>
    </section>
  );
}